export default "__VITE_ASSET__bzwMSVdz__"